import styled from 'styled-components';

interface TitleProps {
	$noUnderline?: boolean;
}

export const Title = styled.h1<TitleProps>`
	font-size: 32px;
	line-height: 100%;
	color: #f47920;
	padding-bottom: ${props => (props.$noUnderline === true ? '0' : '12px')};
	margin-bottom: 24px;
	border-bottom: ${props =>
		props.$noUnderline === true ? 'none' : '2px solid #f47920'};
	width: 100%;
	max-width: 570px;
	font-weight: 700;
	display: flex;
	flex-direction: row;

	@media (max-width: 600px) {
		font-size: 24px;
	}
`;

export const SubTitle = styled.h1`
	font-size: 24px;
	color: #f47920;
	padding-bottom: 12px;
	margin-bottom: 24px;
	border-bottom: 2px solid #f47920;
	width: 100%;
	font-weight: bold;
`;

// interface TitleWithImageProps {
// 	displayText?: string;
// 	iconText?: string;
// 	iconSize?: number;
// }

// export const TitleWithImage: React.FC<TitleWithImageProps> = ({
// 	displayText,
// 	iconText = 'edit',
// 	iconSize = 24
// }) => {
// 	return (
// 		<Title>
// 			<span>{displayText}</span>
// 			<Icon
// 				icon={iconText}
// 				additionalClasses="mt-2 ml-2"
// 				size={iconSize}
// 			/>
// 		</Title>
// 	);
// };

// export default Title;
